// extracted by mini-css-extract-plugin
export default {"file-summary-small":"WAeVe1EINHU12ZMbJ9Ae","status-icon-small":"e4aKbPw1B1jLzUQJoDXj"};